/* ==========================================================
   TAC FILES CLIENT
   Draft ↔ R2
   ========================================================== */


/* ----------------------------------------------------------
   LISTAR ARCHIVOS DEL DRAFT
   ---------------------------------------------------------- */

async function tacDraftListFiles(
  session
) {

  const response =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files",
      {

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          Accept:
            "application/json"

        }

      }
    );


  const result =
    await response.json();


  if (
    !response.ok ||
    !result?.ok
  ) {

    throw new Error(
      result?.error ||
      (
        "files_list_" +
        response.status
      )
    );

  }


  return Array.isArray(
    result.files
  )
    ? result.files
    : [];

}


/* ----------------------------------------------------------
   BORRAR RESERVA / ARCHIVO
   ---------------------------------------------------------- */

async function tacDraftDeleteFile(
  session,
  fileId
) {

  const response =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files/" +
      encodeURIComponent(
        fileId
      ),
      {

        method:
          "DELETE",

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          Accept:
            "application/json"

        }

      }
    );


  const result =
    await response.json();


  if (
    !response.ok ||
    !result?.ok
  ) {

    throw new Error(
      result?.error ||
      (
        "file_delete_" +
        response.status
      )
    );

  }


  return result;

}


/* ----------------------------------------------------------
   NORMALIZAR METADATA REMOTA
   ---------------------------------------------------------- */

function tacDraftNormalizeRemoteFile(
  file,
  originalName = ""
) {

  return {

    id:
      file.id,

    file_id:
      file.id,

    category:
      file.category,

    position:
      Number(
        file.position
      ),

    status:
      file.status,

    object_key:
      file.object_key ||
      null,

    stored_size_bytes:
      file.stored_size_bytes ??
      null,

    etag:
      file.etag ||
      null,

    original_name:
      file.original_name ||
      originalName ||
      ""

  };

}


function tacDraftHttpError(code, status = 0) {
  const error = new Error(code || "network_error");
  error.status = Number(status || 0);
  return error;
}


async function tacDraftCompleteReservedFile(session, fileId, hooks = {}) {
  hooks.onState?.("verifying");
  const response = await fetch(
    TAC_DRAFT_API + "/v1/drafts/" + encodeURIComponent(session.id) +
      "/files/" + encodeURIComponent(fileId) + "/complete",
    { method: "POST", headers: { Authorization: "Bearer " + session.token, Accept: "application/json" } }
  );
  let result = {};
  try { result = await response.json(); } catch (error) {}
  if (!response.ok || !result?.ok || result.file?.status !== "verified") {
    throw tacDraftHttpError(result?.error || "file_complete_" + response.status, response.status);
  }
  return result.file;
}


/* Reconcile the reservation before another PUT. The Worker HEADs R2 first. */
async function tacDraftResumeReservedFile(session, reservedFile, sourceFile = null, hooks = {}) {
  const response = await fetch(
    TAC_DRAFT_API + "/v1/drafts/" + encodeURIComponent(session.id) +
      "/files/" + encodeURIComponent(reservedFile.id) + "/retry-presign",
    { method: "POST", headers: { Authorization: "Bearer " + session.token, Accept: "application/json" } }
  );
  let result = {};
  try { result = await response.json(); } catch (error) {}
  if (!response.ok || !result?.ok) {
    throw tacDraftHttpError(result?.error || "file_reconcile_" + response.status, response.status);
  }
  if (result.action === "already_verified") {
    const records = await tacDraftListFiles(session);
    const actual = records.find(item => item.id === reservedFile.id && item.status === "verified");
    if (!actual) throw new Error("file_reconcile_mismatch");
    return actual;
  }
  if (result.action === "complete") {
    return tacDraftCompleteReservedFile(session, reservedFile.id, hooks);
  }
  if (result.action !== "upload") throw new Error("file_reconcile_invalid");
  if (!sourceFile) throw new Error("reselect_required");
  hooks.onState?.("uploading");
  const putResponse = await fetch(result.upload.url, {
    method: result.upload.method, headers: result.upload.headers, body: sourceFile
  });
  if (!putResponse.ok) throw tacDraftHttpError("file_put_" + putResponse.status, putResponse.status);
  return tacDraftCompleteReservedFile(session, reservedFile.id, hooks);
}


async function tacDraftCancelReplacement(session, fileId) {
  const response = await fetch(
    TAC_DRAFT_API + "/v1/drafts/" + encodeURIComponent(session.id) +
      "/files/" + encodeURIComponent(fileId) + "/replacement",
    { method: "DELETE", headers: { Authorization: "Bearer " + session.token, Accept: "application/json" } }
  );
  if (!response.ok) throw tacDraftHttpError("replacement_cancel_failed", response.status);
}


async function tacDraftReconcileReplacement(session, currentFile, hooks = {}) {
  hooks.onState?.("verifying");
  const response = await fetch(
    TAC_DRAFT_API + "/v1/drafts/" + encodeURIComponent(session.id) +
      "/files/" + encodeURIComponent(currentFile.id) + "/replacement/complete",
    { method: "POST", headers: { Authorization: "Bearer " + session.token, Accept: "application/json" } }
  );
  let result = {};
  try { result = await response.json(); } catch (error) {}
  if (response.ok && result?.ok && result.file?.status === "verified") return result.file;
  const code = String(result?.error || "replacement_complete_" + response.status);
  if (["replacement_upload_not_found", "replacement_validation_failed", "replacement_file_signature_mismatch"].includes(code)) {
    await tacDraftCancelReplacement(session, currentFile.id);
    return { ...currentFile, replacement_pending: false, reconciliation: "replacement_reselect_required" };
  }
  if (code === "replacement_not_found") {
    const records = await tacDraftListFiles(session);
    const actual = records.find(item => item.id === currentFile.id);
    if (actual?.status === "verified" && actual.etag && actual.etag !== currentFile.etag) return actual;
  }
  throw tacDraftHttpError(code, response.status);
}


async function tacDraftReconcileRemoteFiles(session, records) {
  return Promise.all(records.map(file => window.TACFiles.run(async () => {
    try {
      if (file.status === "verified" && file.replacement_pending) {
        return await tacDraftReconcileReplacement(session, file);
      }
      if (file.status !== "verified") {
        return await tacDraftResumeReservedFile(session, file, null);
      }
    } catch (error) {
      return {
        ...file,
        reconciliation: String(error?.message || "") === "reselect_required"
          ? "reselect_required" : "reconciliation_pending"
      };
    }
    return file;
  })));
}


/* ----------------------------------------------------------
   PRIMER UPLOAD
   PRESIGN → PUT → COMPLETE
   ---------------------------------------------------------- */

async function tacDraftUploadFreshFileImpl(
  session,
  file,
  category,
  position,
  hooks = {}
) {

  /* =============================
     PRESIGN
     ============================= */

  const presignResponse =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files/presign",
      {

        method:
          "POST",

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          "Content-Type":
            "application/json",

          Accept:
            "application/json"

        },

        body:
          JSON.stringify({

            category:
              category,

            position:
              position,

            name:
              file.name,

            type:
              file.type,

            size:
              file.size

          })

      }
    );


  const presign =
    await presignResponse.json();


  if (
    !presignResponse.ok ||
    !presign?.ok
  ) {

    throw new Error(
      presign?.error ||
      (
        "file_presign_" +
        presignResponse.status
      )
    );

  }


  /* =============================
     PUT DIRECTO A R2
     ============================= */

  hooks.onReserved?.(presign.file);

  const putResponse =
    await fetch(
      presign.upload.url,
      {

        method:
          presign.upload.method,

        headers:
          presign.upload.headers,

        body:
          file

      }
    );


  if (!putResponse.ok) {

    throw new Error(
      "file_put_" +
      putResponse.status
    );

  }


  /* =============================
     COMPLETE / VERIFY
     ============================= */

  hooks.onState?.("verifying");

  const completeResponse =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files/" +
      encodeURIComponent(
        presign.file.id
      ) +
      "/complete",
      {

        method:
          "POST",

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          Accept:
            "application/json"

        }

      }
    );


  const complete =
    await completeResponse.json();


  if (
    !completeResponse.ok ||
    !complete?.ok ||
    complete.file
      ?.status !==
      "verified"
  ) {

    throw new Error(
      complete?.error ||
      (
        "file_complete_" +
        completeResponse.status
      )
    );

  }


  return complete.file;

}


/* ----------------------------------------------------------
   REEMPLAZAR ARCHIVO EXISTENTE

   El original permanece seguro
   hasta que el nuevo queda verified.
   ---------------------------------------------------------- */

async function tacDraftReplaceFileImpl(
  session,
  currentFile,
  newFile,
  hooks = {}
) {

  /* =============================
     REPLACEMENT PRESIGN
     ============================= */

  const presignResponse =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files/" +
      encodeURIComponent(
        currentFile.id
      ) +
      "/replacement/presign",
      {

        method:
          "POST",

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          "Content-Type":
            "application/json",

          Accept:
            "application/json"

        },

        body:
          JSON.stringify({

            name:
              newFile.name,

            type:
              newFile.type,

            size:
              newFile.size

          })

      }
    );


  const presign =
    await presignResponse.json();


  if (
    !presignResponse.ok ||
    !presign?.ok
  ) {

    throw new Error(
      presign?.error ||
      (
        "replacement_presign_" +
        presignResponse.status
      )
    );

  }


  /* =============================
     PUT CANDIDATA
     ============================= */

  hooks.onReserved?.(presign.file);

  const putResponse =
    await fetch(
      presign.upload.url,
      {

        method:
          presign.upload.method,

        headers:
          presign.upload.headers,

        body:
          newFile

      }
    );


  if (!putResponse.ok) {

    throw new Error(
      "replacement_put_" +
      putResponse.status
    );

  }


  /* =============================
     SWAP SEGURO
     ============================= */

  hooks.onState?.("verifying");

  const completeResponse =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files/" +
      encodeURIComponent(
        currentFile.id
      ) +
      "/replacement/complete",
      {

        method:
          "POST",

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          Accept:
            "application/json"

        }

      }
    );


  const complete =
    await completeResponse.json();


  if (
    !completeResponse.ok ||
    !complete?.ok ||
    complete.file
      ?.status !==
      "verified"
  ) {

    throw new Error(
      complete?.error ||
      (
        "replacement_complete_" +
        completeResponse.status
      )
    );

  }


  return complete.file;

}


/* ----------------------------------------------------------
   PORTADA

   category = cover
   position = 1
   ---------------------------------------------------------- */

async function tacDraftUploadPortadaPhoto(
  file
) {

  if (
    !(file instanceof File)
  ) {

    throw new Error(
      "invalid_cover_file"
    );

  }


  const session =
    await tacEnsureDraftSession();


  const files =
    await tacDraftListFiles(
      session
    );


  const currentFile =
    files.find(
      item =>
        item.category ===
          "cover" &&
        Number(
          item.position
        ) === 1
    );


  let savedFile;


  /*
    CASO A:
    Ya existe portada oficial.

    → replacement seguro
  */

  if (
    currentFile?.id &&
    currentFile.status ===
      "verified"
  ) {

    console.log(
      "[TAC Files] 🔄 Reemplazando portada..."
    );


    savedFile =
      await tacDraftReplaceFile(
        session,
        currentFile,
        file
      );

  }


  /* CASO B: reconciliamos la reserva existente antes de otro PUT. */
  else if (currentFile?.id) {
    savedFile = await tacDraftResumeReservedFile(session, currentFile, file);
  } else {
    savedFile = await tacDraftUploadFreshFile(session, file, "cover", 1);
  }


  const remote =
    tacDraftNormalizeRemoteFile(
      savedFile,
      file.name
    );


  console.log(
    "[TAC Files] ✅ Portada verified:",
    remote.id
  );


  return remote;

}

/* ==========================================================
   GENERIC PHOTO SLOT
   Sirve para estampas, fondos, rompecabezas, etc.
   ========================================================== */

async function tacDraftPersistPhotoSlot(
  {
    session,
    file,
    category,
    position,
    currentFile = null
  }
) {

  if (
    !(file instanceof File)
  ) {

    throw new Error(
      "invalid_photo_file"
    );

  }


  let savedFile;


  /*
    SLOT YA VERIFICADO:
    hacemos replacement seguro.
  */

  if (
    currentFile?.id &&
    currentFile.status ===
      "verified"
  ) {

    savedFile =
      await tacDraftReplaceFile(
        session,
        currentFile,
        file
      );

  }


  /*
    SLOT VACÍO O RESERVA INCOMPLETA.
  */

  else if (currentFile?.id) {
    savedFile = await tacDraftResumeReservedFile(session, currentFile, file);
  } else {
    savedFile = await tacDraftUploadFreshFile(session, file, category, position);
  }


  return tacDraftNormalizeRemoteFile(
    savedFile,
    file.name
  );

}


/* ==========================================================
   MULTI UPLOAD POOL
   Concurrencia máxima configurable.
   ========================================================== */

async function tacDraftUploadPhotoBatch(
  {
    tasks,
    category,
    concurrency = 3,
    onUpdate = null
  }
) {

  const session =
    await tacEnsureDraftSession();


  const serverFiles =
    await tacDraftListFiles(
      session
    );


  /*
    Mapa del estado real que existe
    actualmente en D1/R2.
  */

  const existingByPosition =
    new Map();


  serverFiles
    .filter(
      item =>
        item.category ===
        category
    )
    .forEach(
      item => {

        existingByPosition.set(
          Number(
            item.position
          ),
          item
        );

      }
    );


  const queue =
    tasks.map(
      task => ({
        ...task,

        status:
          "queued",

        remote:
          null,

        error:
          null
      })
    );


  let cursor =
    0;


  const worker =
    async () => {

      while (
        true
      ) {

        const taskIndex =
          cursor++;


        if (
          taskIndex >=
          queue.length
        ) {

          return;

        }


        const task =
          queue[
            taskIndex
          ];


        task.status =
          "uploading";


        if (
          typeof onUpdate ===
            "function"
        ) {

          onUpdate(
            task
          );

        }


        try {

          const currentFile =
            existingByPosition.get(
              Number(
                task.position
              )
            ) || null;


          const remote =
            await tacDraftPersistPhotoSlot({
              session,
              file:
                task.file,
              category,
              position:
                task.position,
              currentFile
            });


          task.remote =
            remote;


          task.status =
            "verified";


          existingByPosition.set(
            Number(
              task.position
            ),
            remote
          );


          console.log(
            "[TAC Files] ✅",
            category,
            "posición",
            task.position,
            "verified"
          );


        } catch (
          error
        ) {

          task.status =
            "failed";


          task.error =
            String(
              error?.message ||
              error
            );


          console.error(
            "[TAC Files] ❌",
            category,
            "posición",
            task.position,
            error
          );

        }


        if (
          typeof onUpdate ===
            "function"
        ) {

          onUpdate(
            task
          );

        }

      }

    };


  const workerCount =
    Math.min(
      3,
      Math.max(
        1,
        Number(
          concurrency
        ) || 1
      ),
      queue.length
    );


  await Promise.all(
    Array.from(
      {
        length:
          workerCount
      },
      () =>
        worker()
    )
  );


  return queue;

}

// Shared by cover, individual slots and legacy batches: never more than 3 transfers.
window.TACFiles = (() => {
  const waiting = [];
  let active = 0;
  let maxActive = 0;
  function run(task) {
    return new Promise((resolve, reject) => {
      waiting.push({ task, resolve, reject });
      drain();
    });
  }
  function drain() {
    while (active < 3 && waiting.length) {
      const job = waiting.shift();
      active++;
      maxActive = Math.max(maxActive, active);
      Promise.resolve().then(job.task).then(job.resolve, job.reject).finally(() => {
        active--;
        drain();
      });
    }
  }
  return { run, metrics: () => ({ active, waiting: waiting.length, maxActive }) };
})();

function tacDraftUploadFreshFile(session, file, category, position, hooks = {}) {
  return window.TACFiles.run(async () => {
    hooks.onState?.('uploading');
    let reservedFile = null;
    try {
      return await tacDraftUploadFreshFileImpl(session, file, category, position, {
        ...hooks,
        onReserved(value) { reservedFile = value; hooks.onReserved?.(value); }
      });
    } catch (error) {
      if (reservedFile?.id) {
        try {
          const records = await tacDraftListFiles(session);
          const actual = records.find(item => item.id === reservedFile.id);
          if (actual?.status === 'verified') return actual;
          if (actual) return await tacDraftResumeReservedFile(session, actual, file, hooks);
        } catch (reconciliationError) {
          if (String(reconciliationError?.message || '') === 'file_reconcile_mismatch') throw reconciliationError;
        }
      }
      throw error;
    }
  });
}

function tacDraftReplaceFile(session, currentFile, file, hooks = {}) {
  return window.TACFiles.run(async () => {
    hooks.onState?.('uploading');
    let reserved = false;
    try {
      return await tacDraftReplaceFileImpl(session, currentFile, file, {
        ...hooks,
        onReserved(value) { reserved = true; hooks.onReserved?.(value); }
      });
    } catch (error) {
      // A complete response may be lost after the swap succeeded. Reconcile first.
      const records = await tacDraftListFiles(session).catch(() => null);
      const actual = records?.find(item => item.id === currentFile.id);
      if (actual?.status === 'verified' && actual.object_key !== currentFile.object_key) {
        return actual;
      }
      if ((reserved || actual?.replacement_pending) && actual?.object_key === currentFile.object_key) {
        const reconciled = await tacDraftReconcileReplacement(session, actual, hooks);
        if (reconciled?.reconciliation === 'replacement_reselect_required') throw error;
        return reconciled;
      }
      throw error;
    }
  });
}
